module.exports = __webpack_public_path__ + "img/clinical-docs.185720b7.png";